import { Button, SvgDownload, TextButton } from '@loomhq/lens';
import React, { useEffect, useState } from 'react';

import { isMac, isWindows } from 'utilities/device';
import { WIN_SUPPORT, fetchLinkByPlatform } from 'utilities/download-desktop';

import DownloadDesktopDropdown from '../download-desktop-dropdown';

export const BUTTON_TYPE_TEXT = 'textButton';

const DownloadButtonBase = ({ buttonType, ...props }) => {
  if (buttonType === BUTTON_TYPE_TEXT) {
    return <TextButton {...props} />;
  }

  return <Button {...props} />;
};

const DownloadDesktopButton = props => {
  const {
    buttonType,
    buttonText = 'Download Desktop App',
    variant = 'primary',
    size = 'medium',
    afterOnClick = () => {},
    hasFullWidth = false,
    hideIcon = false,
  } = props;
  const [downloadLinks, setDownloadLinks] = useState([]);

  useEffect(() => {
    if (isWindows) {
      fetchLinkByPlatform(WIN_SUPPORT).then(setDownloadLinks);
    }
  }, []);

  if (isMac) {
    return (
      <DownloadDesktopDropdown
        hasFullWidth={hasFullWidth}
        afterOnClick={afterOnClick}
        trigger={
          <DownloadButtonBase
            buttonType={buttonType}
            size={size}
            hasFullWidth={hasFullWidth}
            icon={hideIcon ? null : <SvgDownload />}
            variant={variant}
            htmlTag={'a'}
          >
            {buttonText}
          </DownloadButtonBase>
        }
      />
    );
  }

  return (
    <DownloadButtonBase
      buttonType={buttonType}
      hasFullWidth={hasFullWidth}
      icon={hideIcon ? null : <SvgDownload />}
      variant={variant}
      href={downloadLinks[0]}
      htmlTag={'a'}
      size={size}
      isDisabled={!downloadLinks || !downloadLinks.length || !downloadLinks[0]}
      onClick={() => {
        afterOnClick(downloadLinks[0]);
      }}
    >
      {buttonText}
    </DownloadButtonBase>
  );
};

export default DownloadDesktopButton;
